import { v4 as uuidv4 } from "uuid";
import { defaultData as ContactItemDefaultData } from "@/react/components/shared/BuilderUI/DefaultBlocks/Sections/ContactItemBlock/ContactItemBlockDefaultData";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { createPBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const createContactItemBlock = ({
  image = { signedId: "", placeholder: "" },
  text,
}: {
  image: { signedId: string; placeholder?: string };
  text: string;
}): BaseBlock => ({
  ...ContactItemDefaultData,
  id: uuidv4(),
  props: {
    ...ContactItemDefaultData.props,
    content: {
      ...ContactItemDefaultData.props.content,
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "auto",
                height: "2.375rem",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
          },
        }),
        createPBlock({
          text,
        }),
      ],
    },
  },
});
